$(document).on 'turbo:load', ->
  new Sharing()

class Sharing
  constructor: ->
    @bindElements()

  bindElements: =>
    $(document).on 'click.Sharing', '[data-share-popup]', (e) =>
      e.preventDefault()
      popup = $(e.currentTarget)
      w = popup.data("popup-w") || 600
      h = popup.data("popup-h") || 400
      @popupWindow(popup.attr('href'), w, h)

  popupWindow: (url, w, h) =>
    left = (screen.width/2)-(w/2)
    top  = (screen.height/2)-(h/2)
    window.open(
      url,
      '',
      'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left
    )
